import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@/public/icons/approval/close.svg';
import DeactivatedBadge from '@/components/Approval/Common/DeactivatedBadge';
import FixedMemberLock from '@/components/Approval/Common/FixedMemberLock';
import { Referrer } from '../../types';
import { Avatar, ChipRoot, Label, RemoveButton } from './styles';

type P = {
  referrer: Referrer;
  deactivated?: boolean;
  /** 어드민이 양식에 고정한 참조인 — 삭제 버튼 대신 자물쇠 표시 */
  locked?: boolean;
  onRemove: (id: string) => void;
  disabled?: boolean;
};

const getInitial = (name: string) => name?.trim().charAt(0) ?? '';

const ReferrerChip = ({
  referrer,
  deactivated,
  locked,
  onRemove,
  disabled,
}: P) => {
  const { t } = useTranslation();
  const { name, positionName, profileImageUrl } = referrer;
  const displayName = positionName ? `${name} ${positionName}` : name;

  return (
    <ChipRoot $disabled={disabled}>
      <Avatar aria-hidden>
        {profileImageUrl ? (
          <img
            src={profileImageUrl}
            alt=""
            onError={(e) => {
              e.currentTarget.src = '/images/dummy/default-profile.svg';
            }}
          />
        ) : (
          getInitial(name)
        )}
      </Avatar>
      <Label>
        {deactivated && <DeactivatedBadge />}
        {displayName}
      </Label>
      {locked ? (
        <FixedMemberLock target="referrer" compact />
      ) : (
        <RemoveButton
          type="button"
          aria-label={t('{{name}} 삭제', { name })}
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) onRemove(referrer.id);
          }}
        >
          <CloseIcon width={10} height={10} />
        </RemoveButton>
      )}
    </ChipRoot>
  );
};

export default ReferrerChip;
